import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Caliber = () => {
  return (
    <div className="caliber-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Left Side: Text Content */}
          <Col md={6} className="caliber-text">
            <p className="caliber-subtitle">CLIF Score System</p>
            <h2 className="caliber-title">
              A single number to measure job readiness.
            </h2>
            <p className="caliber-description">
              How it works: Communication skills (via video), skill test, goal
              alignment, and learning progress all contribute to the CLIF Score.
              How it works: Communication skills (via video), skill test, goal
              alignment, and learning progress all contribute to the CLIF Score.
            </p>
          </Col>

          {/* Right Side: Image Placeholder */}
          <Col md={6} className="caliber-image">
            <div className="image-placeholder">
              {/* Placeholder for the image of three people */}
              <img
                src="../../../images/recruiters/group-7 copy.jpg" // Replace with actual image URL
                alt="Industry Experts"
                className="img-fluid rounded"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Caliber;
